<template>
    <div class="login-container">
        <div class="login-banner">
            <div class="logo"></div>
        </div>
        <div class="login-form">
            <div class="login-form-inner">
                <img
                    class="logo"
                    src="../../../assets/image/header/logo.jpg"
                    alt
                    srcset
                    style="width: 180px"
                />
                <div class="text">欢迎使用OA管理系统 V1.0</div>
                <div class="form-scan-wrap">
                    <el-form
                        class="form-wrap-left"
                        :model="loginForm"
                        :rules="rules"
                        ref="loginForm"
                        label-width="0px"
                    >
                        <el-form-item label prop="phone">
                            <el-input
                                v-model="loginForm.phone"
                                clearable
                                maxlength="11"
                                placeholder="请输入手机号"
                                autofocus="true"
                            >
                                <i
                                    slot="prefix"
                                    class="el-input__icon el-user"
                                ></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label prop="password">
                            <el-input
                                type="password"
                                v-model="loginForm.password"
                                maxlength="20"
                                placeholder="请输入登录密码"
                            >
                                <i
                                    slot="prefix"
                                    class="el-input__icon el-pwd"
                                ></i>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="form-bottom">
                    <el-checkbox v-model="checked" @change="rememberAccunt"
                        >记住密码</el-checkbox
                    >
                    <el-button
                        type="text"
                        class="changePassword"
                        @click="changePassword"
                        style="padding: 0; line-height: 14px; font-size: 12px"
                        >忘记密码</el-button
                    >
                </div>
                <el-button
                    :loading="logining"
                    :disabled="logining"
                    :class="[
                        'login-btn',
                        { logining: logining },
                        {
                            'login-submit-btn':
                                loginForm.login_name &&
                                loginForm.login_password,
                        },
                    ]"
                    @click="handleLogin()"
                    >{{ logining ? "正在登录..." : "登 录" }}</el-button
                >
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import AES from "crypto-js/aes";
import qs from "qs";
import CryptoJS from "crypto-js";
export default {
    data() {
        return {
            loginForm: {
                phone: "",
                password: "",
            },
            rules: {
                phone: [
                    {
                        required: true,
                        message: "手机号不能为空",
                        trigger: "blur",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "密码不能为空",
                        trigger: "blur",
                    },
                ],
            },
            provinceList: [],
            cityList: [],
            checked: false,
            CRYPTOJSKEY: "abcdefghighkml",
        };
    },
    computed: {
      logining() {
          return this.$store.state.login.logining;
      },
    },
    /* watch:{
      logining:{
        handler(val){
          console.log(val);
        }
      }
    }, */
    created() {
        if (this.$cookie.get("user")) {
            this.decryptAccount();
        }
        document.addEventListener("keydown", this.enterKeyUp);
    },
    methods: {
        enterKeyUp(e) {
            let key = window.event.keyCode || e.keyCode;
            if (key === 13) {
                this.handleLogin();
            }
        },
        /**
         * 路由跳转
         * params { url : 路由路径}
         */
        routerGo(url) {
            this.$router.push(url);
        },
        /**
         * 登录
         */
        handleLogin() {
            this.rememberAccunt();
            this.$refs["loginForm"].validate((valid) => {
                if (valid) {
                    this.$store.commit("LOGINING", true);
                    api.submitLogin(this.loginForm).then((res) => {
                        this.$store.commit("LOGINING", false);
                        if (res && res.code === 200) {
                            localStorage.setItem("token", res.data.token);
                            localStorage.setItem("user_id", res.data.user_id);
                            this.getUserInfo();
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        /**
         * 获取用户信息
         */
        getUserInfo() {
            this.$store.dispatch("getUserInfo");
        },
        /**
         * 修改密码提示框
         */
        changePassword() {
            this.$alert("请联系管理员重置密码", "提示", {
                confirmButtonText: "确定",
                type: "warning",
            });
        },

        /**
         * 记住账号--加密
         */
        rememberAccunt() {
            if (this.checked) {
                const phone = CryptoJS.AES.encrypt(
                    this.loginForm.phone,
                    this.CRYPTOJSKEY
                ).toString();
                const password = CryptoJS.AES.encrypt(
                    this.loginForm.password,
                    this.CRYPTOJSKEY
                ).toString();
                this.$cookie.set("user", phone + "-" + password, 30);
            } else {
                this.$cookie.delete("user");
            }
        },
        /**
         * 记住密码 账号解密
         */
        decryptAccount() {
            const [phone, password] = this.$cookie.get("user").split("-");
            const phoneStr = CryptoJS.AES.decrypt(phone, this.CRYPTOJSKEY);
            const passwordStr = CryptoJS.AES.decrypt(
                password,
                this.CRYPTOJSKEY
            );
            const phoneOrigin = phoneStr.toString(CryptoJS.enc.Utf8);
            const passwordOrigin = passwordStr.toString(CryptoJS.enc.Utf8);
            this.loginForm.phone = phoneOrigin;
            this.loginForm.password = passwordOrigin;
            this.checked = true;
        },
    },
    destroyed() {
        document.removeEventListener("keydown", this.enterKeyUp);
    },
};
</script>
<style lang="scss">
.login-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 15%;
    box-sizing: border-box;
    // background: url("../../../assets/image/login/bg6.jpg") no-repeat;
    background: #373330;
    background-size: 100% 100%;
    position: relative;
    .login-form {
        // width: 3.9rem;
        // height: 3.9rem;
        min-width: 450px;
        min-height: 450px;
        background: #ffffff;
        // border-radius: 4px;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .login-form-inner {
            width: 340px;
            height: 200px;
            position: absolute;
            left: 50%;
            top: 50%;

            .text {
                font-size: 12px;
                color: #898989;
                line-height: 2;
                margin-bottom: 12px;
            }
            .form-scan-wrap {
                width: 100%;
                display: inline-flex;
                justify-content: space-between;
                .form-wrap-left {
                    width: 100%;
                }
                .qrcode {
                    width: 0.55rem;
                    height: 0.55rem;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            transform: translate(-50%, -90%);
            .el-checkbox__input.is-checked + .el-checkbox__label {
                color: #333333;
            }
            .el-checkbox__label {
                font-size: 12px;
                line-height: 14px;
            }
            .el-checkbox__input.is-checked .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                background-color: $theme-color;
                border-color: $theme-color;
            }
            .el-input--prefix .el-input__inner {
                padding-left: 40px;
            }
            .el-user {
                width: 15px;
                height: 19px;
                display: inline-block;
                background: url("../../../assets/image/login/user.png")
                    no-repeat;
                background-size: 100% 100%;
                margin-top: 10px;
                margin-left: 10px;
            }
            .el-pwd {
                width: 15px;
                height: 19px;
                margin-top: 10px;
                margin-left: 10px;
                display: inline-block;
                background: url("../../../assets/image/login/pwd.png") no-repeat;
                background-size: 100% 100%;
            }
            .logo {
                width: 1.5rem;
                margin: 0 auto;
                // margin-bottom: 0.1rem;
            }
            .form-bottom {
                margin-top: 0.1rem;
                margin-bottom: 0.1rem;
            }
            .login-btn {
                color: #fff;
                // color: #333;
                // height: 0.22rem;
                min-height: 40px;
                // line-height: 0.22rem;
                line-height: 40px;
                margin-bottom: 10px;
                cursor: pointer;
                // background: linear-gradient(#17579f, #3274bf);
                // background: linear-gradient($theme-color, #d81519);
                background: $theme-color;
                width: 100%;
                padding: 0;
                border-radius: 0.02rem;
                border: none;
                outline: none;
                &:hover {
                    color: rgb(240, 240, 240);
                }
            }

            .login-submit-btn {
                background: #aed2e1;
            }

            .disabled {
                background: #bdbdbd !important;
                color: white !important;
            }

            .form-bottom {
                text-align: left;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .register-btn,
                .forget-btn {
                    color: $theme-color;
                    font-size: 12px;
                    line-height: 30px;
                    margin: 0 10px;
                    cursor: pointer;
                }

                .register-btn {
                    margin-right: 20px;
                }
                .changePassword {
                    color: $theme-color;
                    font-size: 12px;
                    cursor: pointer;
                }
            }
        }
    }
    .el-form-item {
        margin-bottom: 20px;
    }
}

.company-dialog {
    .el-select {
        width: 100%;
    }

    .company-row {
        margin-top: 20px;
    }
}
</style>
